module.exports = __webpack_public_path__ + "img/emoji_100.5b0af1cf.png";